import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons';

function SubHeader() {
    const [currentTime, setCurrentTime] = useState({ time: "", timezone: "" });

    useEffect(() => {
        const updateTime = () => {
            const now = new Date();

            // Force the time to be in the Central Time Zone
            const options = {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: true,
                timeZone: 'America/Chicago',
            };
            const timeFormatter = new Intl.DateTimeFormat('en-US', options);
            const time = timeFormatter.format(now);

            // Replace timezone abbreviations (CST/CDT) with "Central Time Zone"
            const timezone = now
                .toLocaleString('en-US', {
                    timeZone: 'America/Chicago',
                    timeZoneName: 'short',
                })
                .split(' ')
                .pop()
                .replace(/CST|CDT/, 'Central Time Zone');

            setCurrentTime({ time, timezone });
        };

        updateTime(); // Update immediately
        const intervalId = setInterval(updateTime, 1000); // Update every second

        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    return (
        <section>
            <div className="section-wrapper d-flex justify-content-around align-items-center text-white py-3 regular-font">
                <div className="left-details">
                    <div className="heading large-font fw-bold">Building Permit Application</div>
                </div>
                <div className="icon-date-wrap d-flex align-items-center">
                    <div className="icon">
                        <FontAwesomeIcon className="fa-2xl" icon={faCalendarDays} />
                    </div>
                    <div className="right-details px-4">
                        <div className="time">{currentTime.time}</div>
                        <div className="timezone">{currentTime.timezone}</div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default SubHeader;
